import { useRef } from 'react';
var id = 0;
export default function useId(prefix) {
  var ref = useRef(++id);

  if (prefix) {
    return "".concat(prefix, "-").concat(ref.current);
  }

  return '' + ref.current;
}